import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, filter, map, mergeMap, takeUntil } from 'rxjs/operators'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'

import {
  getMailboxProtectionError,
  getMailboxProtectionSuccess,
  updMailboxProtectionError,
  updMailboxProtectionSuccess,
} from './actions'
import {
  MAILBOX_PROTECTION_REQUEST_ASYNC,
  UPDATE_MAILBOX_PROTECTION_REQUEST_ASYNC,
} from './constants'

const getMailboxProtectionEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      MAILBOX_PROTECTION_REQUEST_ASYNC.INITIATE,
      UPDATE_MAILBOX_PROTECTION_REQUEST_ASYNC.SUCCESS
    ),
    filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.settings.impersonation)
      return true
    }),
    mergeMap(() =>
      api.settings.getBanners(state$.value.partnerOptions.selectedCompany?.value).pipe(
        map((response) => getMailboxProtectionSuccess(response)),
        catchError((error) => of(epicsErrorHandler(getMailboxProtectionError, error))),
        takeUntil(action$.pipe(ofType(MAILBOX_PROTECTION_REQUEST_ASYNC.CANCEL)))
      )
    )
  )

const updMailboxProtectionEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(UPDATE_MAILBOX_PROTECTION_REQUEST_ASYNC.INITIATE),
    mergeMap(() =>
      api.settings
        .updBanners(
          state$.value.partnerOptions.selectedCompany?.value,
          state$.value.settings.mailboxProtection.self.data
        )
        .pipe(
          map((response) => updMailboxProtectionSuccess(response)),
          catchError((error) => of(epicsErrorHandler(updMailboxProtectionError, error))),
          takeUntil(action$.pipe(ofType(UPDATE_MAILBOX_PROTECTION_REQUEST_ASYNC.CANCEL)))
        )
    )
  )

export default combineEpics(getMailboxProtectionEpic, updMailboxProtectionEpic)
